import {BaseEvent} from "./BaseEvent";

export class CreateMetricGroupEvent extends BaseEvent {
  public static NAME = 'createMetricGroupEvent';

  constructor() {
    super(CreateMetricGroupEvent.NAME);
  }
}
